import React from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Chip,
  Dialog,
  Divider,
  Typography,
  InputBase
} from "@mui/material";
import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Grid from "@mui/material/Grid";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import EmployeeTrainingDetails from "./EmployeeTrainingDetails";
import EditEmployeeTraing from "./EditEmployeeTraing";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import useFetch from "../../../utils/useFetch";
import EmployeeView from "./EmployeeView";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Autocomplete } from '@mui/material'
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { getGlobalClientId, } from "../../../utils/Token";
import apiinfo from '../../../utils/base-uri.json';
import { useForm } from 'react-hook-form';
import OutlinedInput from '@mui/material/OutlinedInput';
import Nodata from '../../../pages/Nodata/Nodata';
import { CSVLink } from "react-csv";
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
import ClearIcon from '@mui/icons-material/Clear';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Paginator from "../../../toolkit/Paginator";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import EmployeeList from './EmployeeList'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getOrgType, getUserName, getisEmp, getOrgId } from "../../../utils/Token";
import { groupBy } from 'lodash';
import Mastercard from "../../../icons/Dot.svg"
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import InfoIcon from '@mui/icons-material/Info';


import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import EmployeeSearch from "./EmployeeSearch";
import SearchSIngleDownload from "./SearchSIngleDownload";
import FilterSingleDownloadEmp from "./FilterSingleDownloadEmp";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import BlacklistedNew from "../../../icons/BlackListedNew.svg";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F9FAFB",
    color: "#667085",

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const headers = [
  { label: "Client Name", key: "client" },
  { label: "Vendor Name", key: "vendor" },
  { label: "Employee Name", key: "empName" },
  { label: "Course Name", key: "templateName" },
  { label: "Status", key: "quizResult" },
  { label: "Last Taken On", key: "quizDateStart" },
  { label: "IsBlacklisted", key: "isBlacklisted" },
  { label: "Blacklisted Till", key: "blacklistedTill" }
];


function convertToCSV(data) {
  const header = headers.map(header => `"${header.label}"`).join(',');
  const rows = data.map(item =>
    headers.map(header => `"${item[header.key]}"`).join(',')
  );

  return [header, ...rows].join('\n');
}
function Row(props) {
  const { row, open, onToggle, DeTag } = props;
  // const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [isMoodleEmployee, setisMoodleEmployee] = React.useState("");
  const [GetEmployeeCategories, setGetEmployeeCategories] = useState([]);
  const [userid, setUserid] = useState("");
  const [fvuserid, setFvUserid] = useState("");
  const [deleteEmployee, setDeleteEmployee] = useState();
  useEffect(() => {
    if (props?.closeCollapsed) {

      // setOpen(false)
    }
  }, []);
  const [openpop, setOpenpop] = React.useState(false);
  const [EmpId, setEmpId] = React.useState();
  const handleChange = (event) => {
    setAge(event.text);
  };
  const { t } = useTranslation();
  const handleClickOpenpop = (e) => {
    setEmpId(e)
    setOpenpop(true);
  };

  const handlePopClose = () => {
    setOpenpop(false);
  };

  const EDiThandle = (e) => {
    setGetEmployeeCategories(e);

    setOpen1(true);
  };
  const DeleteEmployee = async () => {
    setOpenpop(false)
    props?.setSpinners(true);
    axios
      .post(
        "Employee/DeleteEmployee?fvUserID=" +
        EmpId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseMessage == "Success") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          props?.setSpinners(false);
          setTimeout(() => {
            props?.setRefres(!props?.refres);
          }, 2000);

        } else {
          toast.error(res?.data.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const handleClickOpen1 = (e) => {
    setOpen2(true);
  };
  const handleClose1 = () => {
    setOpen2(false);
  };
  const [age, setAge] = React.useState("");

  // const handleClickOpen12 = (row) => {

  //   props?.setSpinners(true);

  //   axios
  //     .get("Employee/DownloadEmployeeTrainingSummary?clientId=10&vendorId=12&moodleUserId=12",

  //     )
  //     .then((res) => {
  //       if (res?.data.data == "Success") {

  //         props?.setSpinners(false);

  //       } else {
  //         props?.setSpinners(false);
  //         toast.error(res?.data?.responseMessage, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const [showPdf, setShowPdf] = useState(false);
  const [apiData, setApiData] = useState([]);


  const handleButtonClick = (row) => {
    // Toggle the state to show/hide the Pdf
    setShowPdf(!showPdf);
    setApiData(row);
  };
  const [csvData, setCsvData] = useState(null);

  const handleFetchAndDownloadCSV = (ro) => {
    if (ro && ro?.tranings) {
      const csvData = ro?.tranings?.reduce((acc, training) => {
        return acc.concat({
          client: training?.clientname,
          vendor: ro?.vendorname,
          empName: `${ro?.firstname} ${ro?.lastname}`,
          title: `${ro?.title}`,
          templateName: training?.coursename,
          quizResult: training?.quizstatus,
          quizDateStart: training?.lastwatched
        });
      }, []);

      const headers = [
        { label: "Client Name", key: "client" },
        { label: "Vendor Name", key: "vendor" },
        { label: "Employee Name", key: "empName" },
        { label: "Title", key: "title" },
        { label: "Course Name", key: "templateName" },
        { label: "Status", key: "quizResult" },
        { label: "Last Taken On", key: "quizDateStart" },
      ];

      const header = headers?.map(header => `"${header?.label}"`).join(',');
      const rows = csvData?.map(item =>
        headers.map(header => `"${item[header?.key]}"`).join(',')
      );

      const csvContent = [header, ...rows]?.join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Employee training summary .csv';
      a.click();
      URL.revokeObjectURL(url);
    }

  };

  const Empportal = getisEmp() === "true" ? (!open) : open
  const groupedTrainings = groupBy(row?.tranings, 'clientname');
  const sortedClientNames = Object.keys(groupedTrainings)?.sort()
  return (
    <>

      <React.Fragment>
        <ToastContainer />
        <Dialog
          open={openpop}
          keepMounted
          onClose={handlePopClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle> {"Are you sure you want to delete the employee & associated trainings?"}</DialogTitle>
          <DialogContent>
            {/* <DialogContentText id="alert-dialog-slide-description">
            {t('VendorDetails.label9')}
          </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePopClose}>{"Cancel"}</Button>
            <Button onClick={DeleteEmployee}>{t('VendorDetails.label8')}</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={open1}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <EditEmployeeTraing isMoodleEmployee={isMoodleEmployee}
            userid={userid} refe={props?.refres} setResh={props?.setRefres} fvuserid={fvuserid} spin={props?.spinners} setSpin={props?.setSpinner} userdetails={GetEmployeeCategories} close={handleClose} />
        </Dialog>
        <Dialog
          open={open2}
          onClose={handleClose1}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "1050px",
              },
            },
          }}
        >
          <EmployeeView
            isMoodleEmployee={isMoodleEmployee}
            userid={userid}
            fvuserid={fvuserid}
            close={handleClose1}
          />
        </Dialog>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell style={{ width: "10px" }} hidden={getisEmp() === "true"}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={onToggle}
              sx={{ color: "#667085" }}
              hidden={row?.tranings?.length === 0}
            >
              {Empportal ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          <TableCell hidden={props?.typeorg != "Client"} scope="row" sx={{ color: "#667085", width: "20%" }}>
            {sortedClientNames?.map(clientName => (
              <div key={clientName}>
                <span style={{ padding: "10px", marginTop: "10px" }}>
                  {" "}
                  <Chip
                    sx={{ color: "#344054", fontWeight: "bold" }}
                    label={
                      <span>
                        {Array?.from(new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus)))
                          ?.length >= 2 ? (
                          <div>
                            <svg viewBox="0 0 24 24" width="20" height="20">
                              <circle cx="12" cy="12" r="10" fill="white" />
                              <path
                                d="M12 12 L12 2 A10 10 0 0 1 22 12 Z"
                                fill="#ED8A17"
                              />
                              <path
                                d="M12 12 L22 12 A10 10 0 0 1 12 22 Z"
                                fill="#12B76A"
                              />
                              <path
                                d="M12 12 L12 22 A10 10 0 0 1 2 12 Z"
                                fill="#5925DC"
                              />
                              <path
                                d="M12 12 L2 12 A10 10 0 0 1 12 2 Z"
                                fill="#EE3F3F"
                              />
                            </svg>
                            <span style={{ marginLeft: "2px" }}>Multiple</span>
                          </div>
                        ) : (
                          <span>
                            <FiberManualRecordIcon
                              hidden={
                                Array.from(
                                  new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                                ) != "Passed"
                              }
                              sx={{ color: "#12B76A" }}
                            />{" "}
                            <FiberManualRecordIcon
                              hidden={
                                Array.from(
                                  new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                                ) != "Not Attended"
                              }
                              sx={{ color: "#ED8A17" }}
                            />{" "}
                            <FiberManualRecordIcon
                              hidden={
                                Array.from(
                                  new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                                ) != "Failed"
                              }
                              sx={{ color: "#EE3F3F" }}
                            />{" "}
                            <FiberManualRecordIcon
                              hidden={
                                Array.from(
                                  new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                                ) != "InProcess"
                              }
                              sx={{ color: "#5925DC" }}
                            />{" "}
                            <img
                              src={Mastercard}
                              alt="Expired"
                              style={{ width: "20px", marginRight: "5px" }}
                              hidden={
                                Array.from(
                                  new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                                ) != "Expired"
                              }
                            />{" "}
                            {Array.from(
                              new Set(groupedTrainings[clientName]?.map((r) => r?.quizstatus))
                            )}{" "}
                          </span>
                        )}{" "}
                      </span>
                    }
                  />
                </span>
              </div>
            ))}
          </TableCell>
          <TableCell hidden={props?.typeorg != "Admin"} scope="row" sx={{ color: "#667085", width: "20%" }}>
            <span style={{ fontWeight: open ? 600 : 500, fontSize: "14px" }}>{row?.vendorname}</span>
          </TableCell>
          <TableCell sx={{ color: "#667085", fontWeight: "bold", fontSize: "14px", fontWeight: Empportal ? 600 : 500, fontSize: "14px", width: props?.typeorg === "Client" ? "30%" : (getisEmp() === "true" ? "25%" : "20%") }}>
            {row?.lastname}, {row?.firstname}{row?.title ? " -" : ""}  {row?.title}
          </TableCell>
          <TableCell align="left" sx={{ color: "#667085", width: "20%", fontWeight: Empportal ? 600 : 500, fontSize: "14px", overflowWrap: 'anywhere' }} hidden={props?.typeorg === "Client"}>
            <span> {row?.fvusername}</span>
          </TableCell>
          <TableCell align="left" sx={{ width: getisEmp() === "true" ? "20%" : "10%", color: "#667085", fontWeight: Empportal ? 600 : 500, fontSize: "14px" }} hidden={props?.typeorg === "Client"}>
            <span>  {row?.password}  </span>
          </TableCell>
          <TableCell align="left" sx={{ width: getisEmp() === "true" ? "15%" : "5%", color: "#667085", fontWeight: Empportal ? 600 : 500, fontSize: "14px" }}>
            <span hidden={props?.typeorg === "Client"}> {row?.title}  </span>
          </TableCell>
          <TableCell align="left" sx={{ width: getisEmp() === "true" ? "14%" : "9px", color: "#667085", fontWeight: Empportal ? 600 : 500, fontSize: "14px", }} hidden={props?.typeorg === "Client"}>
            {/* {row?.userid} */}{row?.documenttype ? row?.documenttype : "-"}
          </TableCell>
          <TableCell align="center" sx={{ width: getisEmp() === "true" ? "25%" : "20%", color: "#667085", fontWeight: Empportal ? 600 : 500, fontSize: "14px" }} hidden={props?.typeorg === "Client"}>
            {row?.last4digitsofid}
          </TableCell>
          <TableCell align="center" sx={{ width: props?.typeorg === "Client" ? "20%" : "20px", color: "#667085", fontWeight: Empportal ? 600 : 500, fontSize: "14px" }} onClick={() => handleFetchAndDownloadCSV(row)} hidden={getisEmp() === "true"}>
            <div>
              {(props?.setTrue == true ? (<><SearchSIngleDownload ApiData={apiData} /></>) : (<>
                {/* <FilterSingleDownloadEmp ApiData={apiData} /> */}
                <SaveAltIcon sx={{ color: "#98A2B3", fontWeight: Empportal ? 600 : 500, cursor: "pointer" }} />

              </>))}
            </div>
          </TableCell>
          <TableCell style={{ width: props?.typeorg === "Client" ? "13%" : "2px", fontWeight: open ? 600 : 500, fontSize: "14px" }} hidden={getisEmp() === "true"}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                setisMoodleEmployee(row?.isMoodleEmployee);
                handleClickOpen1(row.userid);
                setUserid(row.userid);
                setFvUserid(row.fvuserid)
              }}
            >
              <Tooltip title="Category Status History" placement="top" arrow>
                <ContentPasteIcon sx={{ color: "#98A2B3", fontWeight: Empportal ? 600 : 500 }} />
              </Tooltip>
            </IconButton>
          </TableCell>
          <TableCell style={{ width: props?.typeorg === "Client" ? "20%" : "2px", fontWeight: Empportal ? 600 : 500, }} hidden={getisEmp() === "true"}>
            <IconButton onClick={() => {
              setisMoodleEmployee(row?.isMoodleEmployee);
              EDiThandle(row);
              setUserid(row?.userid);
              setFvUserid(row?.fvuserid)
            }} aria-label="expand row" size="small">
              <Tooltip title="Edit Employee" placement="top" arrow>
                <EditRoundedIcon sx={{ color: "#98A2B3", fontWeight: Empportal ? 600 : 500 }} /></Tooltip>
            </IconButton>
          </TableCell>

          <TableCell style={{ width: props?.typeorg === "Client" ? "0%" : "2px", fontWeight: Empportal ? 600 : 500 }} hidden={props?.typeorg != "Admin"}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => handleClickOpenpop(row?.fvuserid)}
            >
              <Tooltip title="Delete" placement="top" arrow hidden={props?.typeorg != "Admin"}>
                <DeleteOutlineIcon sx={{ color: "#98A2B3", fontWeight: Empportal ? 600 : 500 }} /></Tooltip>
            </IconButton>
          </TableCell>

          <TableCell style={{ width: props?.typeorg === "Client" ? "15%" : "2px", fontWeight: open ? 600 : 500 }} >
            <Tooltip
              title={
                props?.BlackListInfo?.find((r) => r?.moodleEmpId == row?.userid)
                  ?.isGloballyBlackListed ? (
                  "Globally Blacklisted"
                ) : (
                  (() => {
                    const emp = props?.BlackListInfo?.find(
                      (r) => r?.moodleEmpId == row?.userid
                    );
                    const bl = emp?.blacklistedLocationsInfo ?? [];
                    if (!bl.length) return "";

                    const currentOrgId = String(getOrgId?.());
                    const isClientLogin =
                      String(getOrgType?.()).toLowerCase() === "client";
                    const isAdminLogin =
                      String(getOrgType?.()).toLowerCase() === "admin";

                    if (isClientLogin) {
                      const CLIEID = isClientLogin ? currentOrgId : props?.Clieid
                      const sitesForOrg = bl
                        .filter((loc) => loc.clientId == CLIEID)
                        .map((loc) => loc.siteName);

                      if (!sitesForOrg.length) return "";
                      const Clname = props?.AllClientsList?.length == 0 ? props?.ClientName : props?.AllClientsList

                      const clientMatch = props?.AllClientsList?.find(
                        (c) => c?.clientID == CLIEID
                      );
                      const clientName = clientMatch?.clientName || Clname || CLIEID;
                      return `${clientName} :- (${sitesForOrg.join(", ")})`;
                    }
                    // else if (isAdminLogin && props?.Clieid != "") {
                    //   const Cid = props?.Clieid == -1 ? props?.MultiClientId : props?.Clieid
                    //   const sitesForOrg = bl
                    //     ?.filter((loc) => loc?.clientId == Cid)
                    //     ?.map((loc) => loc?.siteName);
                    //   if (!sitesForOrg?.length) return "";
                    //   const AdminMatch = props?.AllClientsList?.find(
                    //     (c) => c?.clientID == Cid
                    //   );
                    //   const clientName = AdminMatch?.clientName || Cid;

                    //   return `${clientName} :- (${sitesForOrg.join(", ")})`;
                    // }
                    else if (isAdminLogin && props?.Clieid != "") {
                      if (props?.MultiClientId == -1 && Array.isArray(props?.MultiClientInfo)) {
                        const emp = props?.BlackListInfo?.find(
                          (r) => r?.moodleEmpId == row?.userid
                        );

                        if (emp?.isGloballyBlackListed) {
                          return "Globally Blacklisted";
                        }

                        return props?.MultiClientInfo
                          .map((client) => {
                            const sitesForOrg = bl
                              ?.filter((loc) => loc?.clientId == client?.key)
                              ?.map((loc) => loc?.siteName);

                            if (!sitesForOrg?.length) return null;

                            return `${client?.value} :- (${sitesForOrg.join(", ")})`;
                          })
                          .filter(Boolean)
                          .join(" | ");
                      } else {
                        // Single client
                        const Cid = props?.Clieid == -1 ? props?.MultiClientId : props?.Clieid
                        const sitesForOrg = bl
                          ?.filter((loc) => loc?.clientId == Cid)
                          ?.map((loc) => loc?.siteName);

                        if (!sitesForOrg?.length) return "";

                        const AdminMatch = props?.AllClientsList?.find((c) => c?.clientID == Cid);
                        const clientName = AdminMatch?.clientName || Cid;

                        return `${clientName} :- (${sitesForOrg.join(", ")})`;
                      }
                    }


                    // Admin / Global
                    const grouped = bl.reduce((acc, loc) => {
                      const id = String(loc.clientId);
                      acc[id] = acc[id] || [];
                      acc[id].push(loc.siteName);
                      return acc;
                    }, {});

                    return (
                      <div>
                        {Object.entries(grouped).map(([clientId, sites]) => {
                          const clientMatch = props?.AllClientsList?.find(
                            (r) => r?.clientID == clientId
                          );
                          const clientName = clientMatch?.clientName || clientId;
                          return (
                            <div key={clientId}>
                              {clientName} :- ({sites.join(", ")})
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()
                )
              }
              placement="top"
              arrow
            >
              <img
                src={BlacklistedNew}
                alt="Blacklisted"
                width="30"
                height="30"
                style={{ cursor: "pointer" }}
                // hidden={
                //   props?.BlackListInfo?.find((p) => p?.moodleEmpId == row?.useri)
                //     ?.isEmployeeBlackListed != true
                // }
                hidden={(() => {
                  const emp = props?.BlackListInfo?.find(
                    (r) => r?.moodleEmpId == row?.userid
                  );
                  if (!emp?.isEmployeeBlackListed) return true;

                  const orgType = (getOrgType?.() ?? "").toLowerCase();

                  if (orgType === "client") {
                    if (emp?.isGloballyBlackListed) {
                      return false;
                    }
                    const currentOrgId = String(getOrgId?.());
                    return !emp?.blacklistedLocationsInfo?.some(
                      (loc) => String(loc?.clientId) === currentOrgId
                    );
                  }

                  if (orgType === "admin") {
                    if (emp?.isGloballyBlackListed) {
                      return false;
                    }

                    if (String(props?.MultiClientId) === "-1" && Array.isArray(props?.MultiClientInfo)) {
                      const ids = props?.MultiClientInfo.map(c => String(c?.key));
                      return !emp?.blacklistedLocationsInfo?.some(
                        (loc) => ids.includes(String(loc?.clientId))
                      );
                    } else {
                      const Cid = String(props?.Clieid) === "-1" ? props?.MultiClientId : props?.Clieid;
                      return !emp?.blacklistedLocationsInfo?.some(
                        (loc) => String(loc?.clientId) === Cid
                      );
                    }
                  }
                  return false;
                })()}

              />
            </Tooltip>
          </TableCell>
        </TableRow>


        <TableRow>
          <TableCell style={{ width: props?.typeorg === "Client" ? "15%" : "2px", paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={Empportal} timeout="auto" unmountOnExit>
              {props?.setTrue == true ? (<><EmployeeSearch row={row} openTabs={open} DeTag={DeTag} /></>) : (<>
                <EmployeeTrainingDetails row={row} refe={props?.refres} setResh={props?.setRefres} type={props?.typeorg} docclient={props?.clientsDoc} DeTag={DeTag} /></>)}
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment >
    </>
  );
}




export default function Employees() {
  // const DownloadTraingGuide1 = (r) => {
  //     setIsDownloading1(true);
  //     debugger;

  //     axios.get("Employee/DownloadEmpDoc?idAsFileName=" + r.documentId + "&userEnteredFilename=" + r.docName + "&vendorId=" + r.vendorId, { responseType: "arraybuffer" })
  //         .then((res) => {
  //             if (res?.data?.type == "application/json") {
  //                 toast.error("File not found", {
  //                     position: "top-right",
  //                     autoClose: 4000,
  //                     hideProgressBar: false,
  //                     closeOnClick: true,
  //                     pauseOnHover: true,
  //                     draggable: true,
  //                     progress: undefined,
  //                     theme: "light",
  //                 });
  //             } else {
  //                 setIsDownloading1(false);

  //                 const blob = new Blob([res.data], { type: res.headers['content-type'] });
  //                 const objectUrl = URL.createObjectURL(blob);


  //                 window.open(objectUrl, '_blank');
  //             }
  //         }).finally(() => {
  //             setIsDownloading1(false);
  //         });
  // };
  const params = new URLSearchParams(window.location.search);
  const vendorid = params.get("Vendor");
  const clientid = params.get("Client");
  const pqId = params.get("pqId");
  const Tag = params.get("Tag");
  const isMultiClientId = params.get("isMultiClientId");
  const isbAck = params.get("back");
  const navigate = useNavigate();
  const [EmailtemplateLists, setEmailtemplateLists] = useState([]);
  const [UserName, setUserName] = useState('');
  const [Count, setCount] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [PqClients, setPqClients] = useState([]);
  const [selectValue1, setSelectValue1] = useState("0");
  const [refresh, setRefresh] = React.useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);



  const [vendor, setVendor] = useState([]);
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [period, setPeriod] = React.useState([],);
  const [fincialdata, setFincialdata] = React.useState([])
  const [clientID, setClientID] = useState("");
  const [vendorID, setVendorID] = useState("");


  const [istrue, SetIstrue] = React.useState(false);
  const { register } = useForm();
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const employeesPerPage = 10;
  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  // Handle "Go to page" button click
  const [goToPage, setGoToPage] = useState(currentPage); // Initialize the input field with the current page
  // Handle "Go to page" input change

  // const handleGoToPageChange = (event) => {
  //   const value = event.target.value.trim(); // Trim any leading/trailing spaces
  //   // Check if the input is empty or non-numeric
  //   if (value === '' || isNaN(value)) {
  //     setGoToPage(''); // Clear the input field
  //     setCurrentPage(1); // Reset to the first page
  //     return;
  //   }
  //   let parsedValue = Number(value);
  //   // Validate input value
  //   if (parsedValue < 1) {
  //     parsedValue = 1; // Set minimum value to 1
  //   } else if (parsedValue > Math.ceil(totalEmployees / employeesPerPage)) {
  //     parsedValue = Math.ceil(totalEmployees / employeesPerPage); // Set maximum value to the total number of pages
  //   }
  //   setGoToPage(parsedValue);
  //   setCurrentPage(parsedValue); // Automatically update the current page
  // };

  // Handle "Go to page" button click
  // const handleGoToPageClick = () => {
  //   if (goToPage >= 1 && goToPage <= Math.ceil(totalEmployees / employeesPerPage)) {
  //     setCurrentPage(goToPage);
  //   }
  // };
  const [closeCollapse, setCloseCollapse] = useState(false);
  // Handle page change
  const handlePageChange = (event, page) => {
    const isLetter = /^[a-z]$/i.test(event)
    setCurrentPage(event);
    setGoToPage(event);
    setSpinner(!spinner);
  };
  const [totalEmployees1, setTotalEmployees1] = useState(0);
  const [currentPage1, setCurrentPage1] = useState(1);
  const employeesPerPage1 = 10;
  const indexOfLastEmployee1 = currentPage1 * employeesPerPage1;
  const indexOfFirstEmployee1 = indexOfLastEmployee1 - employeesPerPage1;
  // Handle "Go to page" button click
  const [goToPage1, setGoToPage1] = useState(currentPage1); // Initialize the input field with the current page
  // Handle "Go to page" input change
  const handleGoToPageChange1 = (event) => {
    setCloseCollapse(false)
    const value = event?.target?.value.trim(); // Trim any leading/trailing spaces
    // Check if the input is empty or non-numeric
    if (value === '' || isNaN(value)) {
      setGoToPage1(''); // Clear the input field
      setCurrentPage(1); // Reset to the first page
      return;
    }
    let parsedValue = Number(value);
    // Validate input value
    if (parsedValue < 1) {
      parsedValue = 1; // Set minimum value to 1
    } else if (parsedValue > Math?.ceil(totalEmployees1 / employeesPerPage1)) {
      parsedValue = Math?.ceil(totalEmployees1 / employeesPerPage1); // Set maximum value to the total number of pages
    }
    setGoToPage1(parsedValue);
    setCurrentPage1(parsedValue); // Automatically update the current page
  };
  const handlePageChange1 = (event, page) => {
    setCloseCollapse(false)
    setCurrentPage1(page);
    setGoToPage1(page); // Update the input field value when clicking on a pagination number
    setSpinner(!spinner);
  };
  const [spinner, setSpinner] = React.useState(false);
  const [trueset, setTrueset] = React.useState(false);
  const [clients, setclient] = React.useState([]);
  const [AllClients, setAllClients] = React.useState([]);
  const [BlackListEmpInfo, setBlackListEmpInfo] = React.useState([]);
  const [MulticlientInfo, setMulticlientInfo] = React.useState([]);
  const [MulticlientInfoCount, setMulticlientInfoCount] = React.useState('');

  const [selectedClient, setSelectedClient] = useState('');
  const handleChange2 = (event) => {
    setSelectedClient(event?.target?.value);
    setTrueset(true)
  };
  const SpinnerClose = () => {
    setSpinner(false);
  };
  const venid = getOrgType() == "Vendor" ? getOrgId() : vendorid;
  const Cliid = getOrgType() == "Client" ? getOrgId() : clientid;
  const orgtype = getOrgType()
  // console.log(venid);
  // const { data: res } = useFetch(
  //   "Employee/GetVendorEmployeeQuizList?VendorId=" + venid + "&clientId=" + Cliid + "&pageNumber=" + currentPage + "&size=10", false, false, refresh
  // );
  const [textvalue, settextvalue] = useState('');
  useEffect(() => {
    setSpinner(true);
    const URL = textvalue?.length > 1 ? "Employee/GetVendorEmployeeQuizList?VendorId=" + venid + "&clientId=" + Cliid + "&pageNumber=" + currentPage + "&size=10&filter=" + textvalue : "Employee/GetVendorEmployeeQuizList?VendorId=" + venid + "&clientId=" + Cliid + "&pageNumber=" + currentPage + "&size=10"
    axios.get(URL
    ).then((res) => {
      if (res?.data) {
        SetIstrue(false);
        if (res?.data?.data?.employees) {
          setEmailtemplateLists(res?.data?.data?.employees);
          //BlackList Employee
          const userIds = res?.data?.data?.employees?.map(item => String(item.userid));
          axios.post("Employee/GetEmployeesBlackListedInfo", userIds
          ).then((re) => {
            if (re?.data?.responseCode === 100) {
              setBlackListEmpInfo(re?.data?.data);
            }
          }).catch(err => {
            console.log(err)
          })
          if (isMultiClientId == -1) {
            axios.get("Client/GetSubClients?orgId=" + isMultiClientId + "&includeSuperClient=false")
              .then((re) => {
                if (re?.data?.responseCode === 100) {
                  setMulticlientInfo(re?.data?.data);
                  setMulticlientInfoCount(re?.data?.count);
                }
              }).catch(err => {
                console.log(err)
              })
          }

          //
          setUserName(getUserName());
        } else {
          setEmailtemplateLists([]);
        }
        setTotalEmployees(res?.data?.data?.employeescount);
        setclient(res?.data?.data?.clients);
        setAllClients(res?.data?.data?.allClients);
        setCount(res?.data?.data?.employeescount)
        setSpinner(false);
      }
    })

  }, [refresh, textvalue, vendorid, clientid, currentPage]);

  const [download, setDownload] = useState([]);




  useEffect(() => {
    const cli = selectedClient ? selectedClient : Cliid  //'clientid' change to 'Cliid'
    if (trueset || getOrgType() != "Vendor") {
      if (cli !== undefined && vendorid !== undefined) {
        const vId = venid == null ? 0 : venid
        axios.get("Employee/DownloadEmployeeTrainingSummary?clientId=" + cli + "&vendorId=" + vId + "&pqId=" + pqId
        ).then((resp) => {
          if (clientid == (undefined || !null) && vendorid == (undefined || !null)) {
            setDownload([]);
          } else {
            setDownload(resp?.data?.data);
          }

        })
      }
    }
  }, [clientid, venid, selectedClient]);


  const buSites = download?.map((row) => {
    return {
      empName: row?.empName,
      title: row?.title,
      templateName: row?.templateName,
      quizResult: row?.quizResult,
      quizDateStart: row?.quizDateStart ? GetfVDateFormate(row?.quizDateStart, "") : "",
      vendor: row?.vendor,
      client: row?.client,
      moodleUserID: row?.moodleUserID,
      isBlacklisted: row?.isBlacklisted,
      blacklistedTill: GetfVDateFormate(row?.blacklistedTill)
    };
  });
  const headers = [
    { label: "Client Name", key: "client" },
    { label: "Vendor Name", key: "vendor" },
    { label: "Employee Name", key: "empName" },
    { label: "Title", key: "title" },
    { label: "Course Name", key: "templateName" },
    { label: "Status", key: "quizResult" },
    { label: "Last Taken On", key: "quizDateStart" },
    { label: "IsBlacklisted", key: "isBlacklisted" },
    { label: "Blacklisted Till", key: "blacklistedTill" }
  ]


  const csvLink = {
    filename: "Training Summary.csv",
    headers: headers,
    data: buSites,
  };

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };


  const handleKeyPress = (event) => {

    if (event?.key === 'Enter') {

      handleChange(event?.target?.value);
      setSpinner(true);
      settextvalue(event?.target?.value);
      setCurrentPage(1)
      // axios
      //   .get("Employee/GetVendorEmployeeQuizList?VendorId=" + venid + "&clientId=" + Cliid + "&pageNumber=" + currentPage + "&filter=" + event.target.value + "&size=10", false, false, refresh
      //   )
      //   .then((res) => {
      //     if (res.data) {
      //       SetIstrue(false)
      //       setEmailtemplateLists(res?.data?.data?.employees);
      //       setTotalEmployees(res?.data?.data?.employeescount);
      //       setclient(res?.data?.data?.clients);
      //       setCount(res?.data?.data?.employeescount)

      //       setSpinner(false);
      //     } else {
      //       setError(res.data.responseMessage);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    }
  };

  const handleChange = (value) => {

  };


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [openRow, setOpenRow] = useState(0);

  const handleToggle = (index) => {
    setOpenRow((prevOpenRow) => (prevOpenRow === index ? null : index));
  };

  useEffect(() => {
    // Close all items when the component mounts
    setOpenRow(null);
  }, []);

  // useEffect(() => {
  //   const successData = { status: "success" };
  //   window.parent.postMessage(successData, "*");
  //   window.top.location.href = "/EmployeesList";
  // }, []);

  const [isDownloading, setIsDownloading] = useState(false);
  const DownloadTraingGuide = () => {
    setIsDownloading(true);
    axios.get("Documents/DownloadDoc?fileName=Employer Guide-Adding employees.pdf", {
      responseType: 'blob'
    })
      .then(res => {
        setIsDownloading(false);
        const file = new Blob([res?.data], { type: "application/pdf", name: "Employer Guide-Adding employees.pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');
      });
  }

  return (
    <div>
      <a hidden={getisEmp() == "true" || getOrgType() == "Vendor" || isbAck != "true"} href={"/vendordetails?pqid=" + pqId + "&tab=Questionnaire"} style={{ textTransform: "capitalize", textDecoration: "none", color: "rgb(97, 169, 251)" }} >{"<-- Back to Questionnaire"}</a>


      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-title">Please select the client</DialogTitle>
        <DialogContent style={{ width: "500px" }}>
          <div style={{ marginLeft: "25px" }}>
            <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>clients</span>
            <br />
            <FormControl>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedClient}
                onChange={handleChange2}
                sx={{ width: "400px" }}
                size="small"
                MenuProps={MenuProps}
              >
                {clients?.map((client) => (
                  <MenuItem key={client?.clientID} title={client?.clientName} value={client?.clientID}>
                    {client?.clientName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button variant="contained" className="login-help-button-cancel" onClick={handleClose}> Cancel</Button>
              {selectedClient == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={handleClose}
                      disabled={selectedClient == ""}
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <CSVLink variant="contained"  {...csvLink} >
                  <Button variant="contained" size="medium" onClick={() => setTrueset(true)} className="login-button-request">
                    Download
                  </Button>
                </CSVLink>
              )}
            </div>

          </DialogActions>


          <br />

        </DialogContent>
      </Dialog>
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={spinner}
          onClick={SpinnerClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box sx={{ padding: "20px" }}>
          <span onClick={() => {
            navigate("/vendordetails?pqid=" + pqId + "&ClientId=" + isMultiClientId)
          }} hidden={Tag != 1} style={{ fontSize: "17px", fontWeight: "600", color: "#0d6efd", cursor: "pointer" }}>
            {"<- Back to questionnaire"}
          </span>
          <br />
          <span style={{ fontSize: "28px", fontWeight: "600", color: "#101828" }} hidden={getisEmp() != "true" || !UserName}>
            {EmailtemplateLists[0]?.vendorname} - {UserName}
          </span>
          <br hidden={getisEmp() != "true"} />
          <br hidden={getisEmp() != "true"} />
          <span hidden={getisEmp() != "true"} style={{ fontSize: "28px", fontWeight: "600", color: "#101828" }}>
            Dashboard
          </span>

          {orgtype == "Vendor" ? <>
            <Button variant="outlined" onClick={handleClickOpen} style={{ float: "right", padding: "10px", display: getisEmp() == "true" ? "none" : "" }} >
              Download Employee Summary
            </Button>


          </> : (buSites?.length > 0 ? (
            <CSVLink variant="contained" style={{ float: "right" }} {...csvLink} hidden={getisEmp() == "true"}>
              <Button variant="contained" size="medium" onClick={() => setTrueset(true)}>
                <SaveAltIcon sx={{ marginRight: "5px" }} /> Download Employee Summary
              </Button>
            </CSVLink>
          ) : (
            <p></p>
          ))}
          <Box sx={{ backgroundColor: "#fff", padding: "10px" }}>
            <Box>


              <Grid container>
                <Grid item xs={12} md={7}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <span

                        style={{ fontSize: "18px", fontWeight: "500", color: "#3E4A62", display: getisEmp() == "true" ? "none" : "" }}
                      >
                        Employees List
                      </span>
                      <br style={{ display: getisEmp() == "true" ? "none" : "" }} />
                      <br style={{ display: getisEmp() == "true" ? "none" : "" }} />
                      {getOrgType() == "Vendor" ? (
                        <>
                          {isDownloading ? (
                            <CircularProgress />
                          ) : (
                            <a className="mt-2" style={{ color: "#2A93DB", fontSize: "14px", cursor: "pointer", textDecoration: "none", display: getisEmp() == "true" ? "none" : "" }} onClick={DownloadTraingGuide}>
                              <InsertDriveFileOutlinedIcon /> Employer Guide-Adding employees.pdf
                            </a>
                          )}
                        </>) : ""}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={2}>
                  <Button variant="contained" size="medium" hidden={true}>
                    <SaveAltIcon sx={{ marginRight: "5px" }} />Upload Employees
                  </Button>
                </Grid>
                {/* <Grid item xs={12} md={1}>
                <Button hidden={true} variant="contained" size="medium" sx={{ padding: "13px" }} onClick={() => navigate("/AddEmployee")}>
                  +  Add New
                </Button>
               </Grid> */}
                <Grid item xs={12} md={3}>

                  <TextField
                    hidden={getisEmp() === "true"}
                    id="outlined-basic"
                    variant="outlined"
                    sx={{ width: "300px", marginTop: "5px" }}
                    placeholder="Search"
                    size="small"
                    type="text"
                    onKeyPress={handleKeyPress}
                    onChange={(event) => handleChange(event?.target?.value)}
                  />
                </Grid>
              </Grid>
              <br />
              <div hidden={spinner || getisEmp() === "true"}>Total Employees : {totalEmployees}</div>
            </Box>
            <hr sx={{ backgroundColor: "#E4E7EC;", height: "1px" }} hidden={getisEmp() === "true"} />

            <TableContainer component={Paper} sx={{ marginTop: "10px", marginBottom: "30px" }} hidden={EmailtemplateLists?.length == 0}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell hidden={getisEmp() === "true"} />
                    <StyledTableCell align="left" hidden={orgtype != "Client"}></StyledTableCell>
                    <StyledTableCell align="left" hidden={orgtype != "Admin"}>Vendor</StyledTableCell>
                    {/* <StyledTableCell align="left" sx={{display:istrue?"none":""}}>Status</StyledTableCell> */}
                    <StyledTableCell align="left">Employee Name</StyledTableCell>
                    <StyledTableCell align="left" hidden={orgtype === "Client"}>Email</StyledTableCell>
                    <StyledTableCell align="left" hidden={orgtype === "Client"}>Password</StyledTableCell>
                    <StyledTableCell align="left" hidden={orgtype === "Client"}>Title</StyledTableCell>
                    <StyledTableCell align="left" hidden={orgtype === "Client"}>ID Type</StyledTableCell>
                    <StyledTableCell align="center" hidden={orgtype === "Client"}>
                      Last 4 Digits of ID
                    </StyledTableCell>

                    <StyledTableCell align="left" hidden={orgtype === "Client"}>&nbsp;</StyledTableCell>

                    <StyledTableCell align="left" hidden={getisEmp() === "true"}>&nbsp;</StyledTableCell>
                    <StyledTableCell align="left" hidden={getisEmp() === "true"}>&nbsp;</StyledTableCell>
                    <StyledTableCell align="left" hidden={getisEmp() === "true"}>&nbsp;</StyledTableCell>
                    <StyledTableCell align="left" >&nbsp;</StyledTableCell>
                    <StyledTableCell align="left" hidden={orgtype != "Client"} >&nbsp;</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {EmailtemplateLists?.map((row, index) => (
                    <Row key={index} index={index} row={row} typeorg={orgtype} setTrue={istrue} onToggle={() => handleToggle(index)} open={openRow === index} closeCollapsed={closeCollapse}
                      setSpinners={setSpinner} spinners={!spinner} setRefres={setRefresh} refres={refresh} venid={vendorid} clid={clientid} Clieid={Cliid} clientsDoc={clients}
                      ClientName={row?.tranings[0]?.clientname} DeTag={Tag} BlackListInfo={BlackListEmpInfo} MultiClientId={isMultiClientId}
                      MultiClientInfoCount={MulticlientInfoCount} MultiClientInfo={MulticlientInfo} AllClientsList={AllClients}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div hidden={EmailtemplateLists?.length == 0 || getisEmp() === "true"}>
              {istrue == false ? (
                <div hidden={spinner || !EmailtemplateLists} style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>

                  <Paginator
                    count={Math?.ceil(totalEmployees / employeesPerPage)}
                    page={Number(currentPage)}
                    num={currentPage}
                    margin="18px 0px"
                    onChange={handlePageChange}
                  />
                </div>) : (
                <div hidden={spinner || getisEmp() == "true"} style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>
                  <Pagination
                    count={Math?.ceil(totalEmployees1 / employeesPerPage1)}
                    // page={currentPage1}
                    page={currentPage1 === 0 ? 1 : currentPage1}
                    shape="rounded" color="primary"
                    onChange={handlePageChange1}
                  />
                  <div style={{ marginLeft: '1rem', display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body2" style={{ marginRight: '0.5rem' }}>
                      Go to Page
                    </Typography>
                    <TextField id="outlined-basic" variant="outlined"
                      sx={{ width: "100px" }}
                      placeholder="Page"
                      size="small"
                      type="text"
                      value={goToPage1}
                      onChange={handleGoToPageChange1}
                      max={Math.ceil(totalEmployees1 / employeesPerPage1)}
                      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    />
                  </div>

                </div>)}
            </div>
          </Box>
          <div hidden={spinner} style={{ display: EmailtemplateLists?.length > 0 ? "none" : "" }}> <Nodata /></div>
        </Box>
      </>


    </div>
  )
}
